var _path, _g, _circle, _circle2, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorOpinion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 67,
    viewBox: "0 0 77 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M39.9962 6.83637C35.1647 7.90573 31.1154 10.348 28.6469 14.0952C26.6163 17.1783 25.4291 20.752 22.5289 23.3653C19.4392 26.149 16.9322 27.6065 12.5632 28.0381C-3.36809 29.6126 -2.73294 52.1987 12.171 61.1886C27.0749 70.1784 59.2364 68.9883 68.5188 42.9508C77.8013 16.9134 64.2058 9.83354 53.0273 7.02431C48.9591 6.00172 44.2746 5.88947 39.9962 6.83637Z",
    fill: "#E7EDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2950_68505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8154 31.9453V54.9464C28.8154 57.156 29.633 60.4372 33.6647 60.4372C37.6964 60.4372 38.7244 57.156 38.7244 54.9464V40.306C38.7244 38.9641 39.4056 36.2805 42.1306 36.2805C44.8555 36.2805 46.1892 36.2805 46.9117 36.2805",
    stroke: "#FF8165",
    strokeWidth: 1.20996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8984 20.9844C20.6816 26.2172 24.2835 30.4745 29.7812 30.4745C33.9179 30.4745 37.3778 26.5828 38.5514 20.9844",
    stroke: "#1552E8",
    strokeWidth: 1.20996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5674 31.9453V54.9464C29.5674 57.156 30.3849 60.4372 34.4166 60.4372C38.4483 60.4372 39.4763 57.156 39.4763 54.9464V40.306C39.4763 38.9641 40.1576 36.2805 42.8825 36.2805C45.6075 36.2805 46.9411 36.2805 47.6636 36.2805",
    stroke: "#081E54",
    strokeWidth: 1.94459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3477 8.42969V21.1255C19.4509 24.6349 21.5772 31.6538 29.2566 31.6538C36.936 31.6538 39.0623 24.6349 39.1655 21.1255V8.42969",
    stroke: "#081E54",
    strokeWidth: 1.94459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3477 18.3906C20.4831 20.6614 24.0544 25.203 29.2566 25.203C34.4588 25.203 38.0301 20.6614 39.1655 18.3906",
    stroke: "#081E54",
    strokeWidth: 1.94459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.3484,
    cy: 5.62283,
    r: 3.75918,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.94459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 9.38201C41.2429 9.38201 42.926 7.69897 42.926 5.62283C42.926 3.54669 41.2429 1.86364 39.1668 1.86364C37.0906 1.86364 35.4076 3.54669 35.4076 5.62283C35.4076 7.69897 37.0906 9.38201 39.1668 9.38201Z",
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.94459
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.2698,
    cy: 36.2483,
    r: 4.00268,
    stroke: "#081E54",
    strokeWidth: 1.20996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.2967,
    cy: 36.2117,
    r: 2.61796,
    fill: "#A020FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.77287,
    cy: 34.4262,
    r: 1.45921,
    stroke: "#081E54",
    strokeWidth: 0.621453
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.9548,
    cy: 20.3425,
    r: 2.93025,
    stroke: "#081E54",
    strokeWidth: 0.621453
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7126 34.3617C69.7126 34.0497 69.964 33.7969 70.2743 33.7969L75.1053 33.7969C75.4156 33.7969 75.667 34.0497 75.667 34.3617C75.667 34.6737 75.4156 34.9265 75.1053 34.9265L70.2743 34.9265C69.964 34.9265 69.7126 34.6737 69.7126 34.3617Z",
    fill: "#3A6EEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1315 36.7899L72.1315 31.932C72.1315 31.62 72.3829 31.3672 72.6932 31.3672C73.0035 31.3672 73.2549 31.62 73.2549 31.932L73.2549 36.7899C73.2549 37.1019 73.0035 37.3547 72.6932 37.3547C72.3829 37.3547 72.1315 37.1019 72.1315 36.7899Z",
    fill: "#3A6EEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2950_68505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.2267,
    height: 62.2267,
    fill: "white",
    transform: "translate(6.19043 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorOpinion);
export default __webpack_public_path__ + "static/media/DoctorOpinion.341bb1b5072ea7b69fc9349b1829a2b2.svg";
export { ForwardRef as ReactComponent };